module.exports = __webpack_public_path__ + "static/img/logo_f.10735c3.png";